import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'dibs-elements/exports/Button';

import classnames from 'classnames';
import styles from './ContemporaryLandingFeaturedRowItem.scss';
import { trackEvent } from 'dibs-tracking';

const trackClick = item => {
    trackEvent({
        action: 'More Ways to Shop',
        category: 'contemporary landing page interaction',
        event: 'e_ga_event',
        label: `${item.title} clicked`,
    });
};

export const ContemporaryLandingFeaturedRowItem = ({ item, rowIndex }) => {
    if (!item) {
        return null;
    }

    const wrapperClasses = classnames('colXs12 colLg6', styles.rowItem, {
        [styles.firstRow]: rowIndex === 0,
    });

    return (
        <div className={wrapperClasses}>
            <div className="rowFlex">
                <div className="colXs6 colLg7">
                    <a
                        className={styles.imageWrapper}
                        href={item.linkPath}
                        onClick={() => trackClick(item)}
                    >
                        {item.imagePath ? (
                            <img className={styles.image} src={item.imagePath} alt={item.title} />
                        ) : (
                            <div className={styles.imagePlaceholder} />
                        )}
                    </a>
                </div>
                <div className="colXs6 colLg5 colXsCenter">
                    <h3 className={styles.title}>{item.title}</h3>
                    <p className={styles.description}>{item.description}</p>
                    <Button
                        href={item.linkPath}
                        className={styles.button}
                        size="small"
                        type="secondary"
                        onClick={() => trackClick(item)}
                    >
                        {item.cta}
                    </Button>
                </div>
            </div>
        </div>
    );
};

ContemporaryLandingFeaturedRowItem.propTypes = {
    item: PropTypes.object,
    rowIndex: PropTypes.number.isRequired,
};
